let url = '',
    devUser = '';
//开发环境接口地址
url = 'https://scalendar.mingyuanyun.com'; //正式
// url= 'http://10.21.42.32:6999'; //张杰
// url = 'http://139.217.16.75:35027'; //rdc
// url='http://10.21.41.24:9004' //王浩


//开发环境登录用户
// devUser = 'ganhd';
// devUser = 'jiangs66';
// devUser = 'hupc01';
// devUser = 'nil01';
// devUser = 'wuy40';
devUser = 'changlj';

exports.url = url;
exports.devUser = devUser;
